<script setup lang="ts">
  import { InformationCircleIcon } from '@heroicons/vue/20/solid';
  import { computed } from 'vue';

  const props = withDefaults(
    defineProps<{
      text: string;
      size?: 'sm' | 'md' | 'lg';
    }>(),
    {
      size: 'md',
    }
  );

  const classNames = computed(() => {
    switch (props.size) {
      case 'sm':
        return 'w-4 h-4';
      case 'md':
        return 'w-5 h-5';
      case 'lg':
        return 'w-6 h-6';
      default:
        return 'w-5 h-5';
    }
  });
</script>

<template>
  <div
    class="tooltip align-middle"
    :data-tip="text">
    <InformationCircleIcon
      class="text-info"
      :class="classNames" />
  </div>
</template>
